export function createPermId() {
  return (Math.random() + Date.now()).toFixed(4)
}

export function isValidPermId(permId: string) {
  return /^[\d]+\.[\d]{4}$/.test(permId)
}
